import { useState, useEffect } from 'react';
import { debounce } from 'lodash';

export function useResizeListener(callback?: (size?: { width: number; height: number }) => void) {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = debounce(() => {
      const size = {
        width: window.innerWidth,
        height: window.innerHeight,
      };
      callback?.(size);
      setWindowSize(size);
    }, 50, { leading: true, trailing: true });

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [callback]);

  return windowSize;
}
